/**
 * CHẾ ĐỘ GỌN cho bảng Station Management — bản DỰNG THỬ để Quân duyệt (28/08/2026).
 *
 * Vì sao là một cái CÔNG TẮC chứ không phải xoá thẳng cột: Quân cần **so sánh
 * trước/sau trên chính màn thật**, không phải trên một trang mockup vẽ lại. Bấm
 * công tắc là thấy ngay mất gì, được gì. Duyệt xong mới gỡ hẳn cột thừa.
 *
 * Nhánh này là `design/station-management-lean` — KHÔNG merge thẳng.
 */

/** Bảng mặc định mở ở chế độ gọn để Quân thấy đề xuất trước. */
export const MAC_DINH_GON = true;

const KHOA = "whalelo.admin.stationTableLean";

export function docCheDoGon(): boolean {
	try {
		const v = localStorage.getItem(KHOA);
		return v === null ? MAC_DINH_GON : v === "1";
	} catch {
		return MAC_DINH_GON;
	}
}

export function ghiCheDoGon(gon: boolean): void {
	try {
		localStorage.setItem(KHOA, gon ? "1" : "0");
	} catch {
		/* trình duyệt chặn lưu thì thôi, không chặn người dùng */
	}
}

/**
 * Loại tài khoản station — Quân chốt 28/08 (3 loại) + 08/10 (chế độ chuỗi TẮT).
 *
 * `…Tat` = có Store nhưng `Stores.chainModeEnabled = false`: Admin chưa bật (9 store
 * legacy prod) hoặc vừa chuyển về "điểm lẻ". Hệ đối xử họ như trạm lẻ, nhưng vẫn
 * hiện là hai loại riêng để rà soát thấy ngay còn ai chưa được quyết.
 */
export type LoaiTaiKhoan = "single" | "trongChuoi" | "chuChuoi" | "chuChuoiTat" | "trongChuoiTat";

export const NHAN_LOAI: Record<LoaiTaiKhoan, { chu: string; nen: string; mau: string; vien: string }> = {
	single: { chu: "Single", nen: "#f5f5f5", mau: "#546e7a", vien: "#e0e0e0" },
	trongChuoi: { chu: "In chain", nen: "#e8f0fe", mau: "#1565c0", vien: "#bbdefb" },
	chuChuoi: { chu: "Chain owner", nen: "#f3e5f5", mau: "#7b1fa2", vien: "#e1bee7" },
	chuChuoiTat: { chu: "Chain owner · OFF", nen: "#f5f5f5", mau: "#7b1fa2", vien: "#e1bee7" },
	trongChuoiTat: { chu: "In chain · OFF", nen: "#f5f5f5", mau: "#1565c0", vien: "#bbdefb" },
};

/** Chế độ chuỗi của store đang BẬT? Thiếu field (API cũ) ⇒ coi là bật, giữ hành vi trước 08/10. */
export function cheDoChuoiBat(p: any): boolean {
	const v = p?.store?.chainModeEnabled;
	return v === undefined || v === null ? true : Boolean(v);
}

/**
 * Suy ra loại tài khoản từ dữ liệu API đang có sẵn.
 *
 * `partnerRoleId === 2` là StoreOwner. Nhưng chỉ tin mỗi cột đó thì hụt: vài bản
 * ghi cũ chưa có role. Nên đối chiếu thêm `store.storeOwnerPartnerId` — nếu chính
 * nó là chủ store thì đó là tài khoản chủ chuỗi, dù role còn trống.
 */
export function suyLoaiTaiKhoan(p: any): LoaiTaiKhoan {
	const store = p?.store || null;
	const laChu = Number(p?.partnerRoleId) === 2 || (store && Number(store.storeOwnerPartnerId) === Number(p?.id));
	const bat = cheDoChuoiBat(p);
	if (laChu) return bat ? "chuChuoi" : "chuChuoiTat";
	if (p?.storeId || store) return bat ? "trongChuoi" : "trongChuoiTat";
	return "single";
}

/**
 * Tài khoản này có phải một STATION (nơi nhận giữ đồ) không — Quân chốt 17/10/2026: Station là
 * tên gốc. Chỉ tài khoản chủ chuỗi THUẦN (không toạ độ, chưa từng published) là không phải
 * station; chủ chuỗi vừa nhận khách (HK Busline, Miraton) VẪN là station. Cùng luật với
 * `ownerIsLocation` ở backend (chainOverviewService).
 */
export function laStation(p: any): boolean {
	const loai = suyLoaiTaiKhoan(p);
	if (loai !== "chuChuoi" && loai !== "chuChuoiTat") return true;
	return Boolean(p?.lat && p?.long) || String(p?.lifecycleStatus || "") === "published";
}

/** Tên chuỗi để hiện dòng phụ dưới tên điểm. */
export function tenChuoi(p: any): string | null {
	const email = p?.store?.storeOwnerUser?.email;
	return email ? String(email) : null;
}

/**
 * Hai công tắc "Meet tab" · "Nearby tab" của trang landing station — Quân chốt
 * 29/08/2026 ẩn khỏi MỌI chỗ hiển thị trong Admin.
 *
 * · `stationShowNearbyTab`: grep toàn `whalelo-frontend` 29/08 — KHÔNG trang khách
 *   nào đọc cờ này. Bật hay tắt đều không đổi gì ⇒ cờ chết.
 * · `stationShowMeetTab`: có tác dụng thật (khối "Meet your Station"), nhưng
 *   0/302 station từng tắt (đo prod 28/08).
 *
 * GIỮ NGUYÊN giá trị trong CSDL và luồng lưu — chỉ giấu khỏi màn hình. Cần bật lại
 * thì đổi hằng này thành `true`, không phải đi tìm lại code.
 */
export const HIEN_CONG_TAC_TAB_TRANG_KHACH = false;

/**
 * 18/10/2026 — Station Management tách 2 chế độ xem Stations | Chains (Quân: "phải tách bảng coi station lẻ,
 * coi chuỗi, và station trong chuỗi"). Bộ lọc loại GỌN còn 4 lựa chọn; trạng thái ON/OFF của chuỗi vẫn hiện
 * ở nhãn cột Type. Hàm THUẦN để test được (1000 ca ngẫu nhiên — __tests__/locTramChuoi.test.ts).
 *   ""              tất cả
 *   "single"        trạm lẻ (không thuộc chuỗi nào)
 *   "inChain"       TRẠM thuộc một chuỗi (kể cả chủ chuỗi vừa nhận khách như HK #285; chuỗi bật hay tắt)
 *   "chainAccount"  tài khoản chủ chuỗi (thuần quản lý hoặc vừa là trạm)
 */
export type LocTram = "" | "single" | "inChain" | "chainAccount";

/** Chuỗi (store) mà tài khoản này thuộc về; không thuộc chuỗi nào ⇒ null. */
export function chuoiCua(p: any): number | null {
	const id = Number(p?.storeId || p?.store?.id || 0);
	return id > 0 ? id : null;
}

export function khopLocTram(p: any, loc: LocTram, chuoiId: number | null = null): boolean {
	if (chuoiId && chuoiCua(p) !== chuoiId) return false;
	const loai = suyLoaiTaiKhoan(p);
	switch (loc) {
		case "single":
			return loai === "single";
		case "inChain":
			return chuoiCua(p) !== null && laStation(p);
		case "chainAccount":
			return loai === "chuChuoi" || loai === "chuChuoiTat";
		default:
			return true;
	}
}

export function locDanhSachTram<T>(list: T[], loc: LocTram, chuoiId: number | null = null): T[] {
	if (!loc && !chuoiId) return list;
	return list.filter((p) => khopLocTram(p, loc, chuoiId));
}
